import { Handle, Position } from "reactflow";
import { twMerge } from "tailwind-merge";
import { X } from "lucide-react";
import { useStore } from "../store";

export const BaseNode = ({
  id,
  title,
  children,
  leftHandles = [],
  rightHandles = [],
  width = 240, // Increased default width
  className,
}) => {
  const removeNode = useStore((state) => state.removeNode);

  return (
    <div
      style={{ width }}
      className={twMerge(
        "bg-white border border-stone-400 shadow-xl rounded-2xl transition-all duration-200 group relative hover:shadow-2xl hover:-translate-y-1 hover:border-primary/50",
        "dark:bg-gray-900/90 dark:backdrop-blur-xl dark:border dark:border-white/10 dark:shadow-none dark:hover:border-purple-500/50 dark:hover:shadow-[0_0_20px_rgba(168,85,247,0.15)]",
        className
      )}
    >
      {/* Header */}
      <div className="px-5 py-4 flex items-center justify-between">
        <span className="font-bold text-base text-gray-900 dark:text-gray-100 tracking-tight">
          {title}
        </span>
        <button
          onClick={() => removeNode(id)}
          className="p-1 rounded-full hover:bg-red-100 dark:hover:bg-white/10 text-gray-400 hover:text-red-500 transition-colors"
        >
          <X size={16} />
        </button>
      </div>

      {/* Body */}
      <div className="px-5 pb-5 text-sm text-gray-500 dark:text-gray-400 space-y-4 font-sans font-medium">
        {children}
      </div>

      {/* Left (Input) Handles */}
      {leftHandles.map((handle) => (
        <div
          key={handle.id}
          className="absolute left-0 flex items-center justify-end w-0"
          style={{ top: handle.top }}
        >
          <div className="absolute right-4 top-1/2 -translate-y-1/2">
            <span className="text-xs text-stone-500 dark:text-stone-400 font-medium whitespace-nowrap opacity-40 group-hover:opacity-100 transition-opacity duration-200 block text-right">
              {handle.label}
            </span>
          </div>
          <Handle
            type="target"
            position={Position.Left}
            id={handle.id}
            className="!w-3 !h-3 !bg-white !border-2 !border-primary/60 dark:!border-primary/80 dark:!bg-dark-bg transition-all hover:!border-primary hover:!bg-primary/10 hover:scale-110 !absolute !left-[-6px] !top-[-6px] !transform-none"
          />
        </div>
      ))}

      {/* Right (Output) Handles */}
      {rightHandles.map((handle) => (
        <div
          key={handle.id}
          className="absolute right-0 flex items-center w-0"
          style={{ top: handle.top }}
        >
          <div className="absolute left-4 top-1/2 -translate-y-1/2">
            <span className="text-xs text-stone-500 dark:text-stone-400 font-medium whitespace-nowrap opacity-40 group-hover:opacity-100 transition-opacity duration-200 block text-left">
              {handle.label}
            </span>
          </div>
          <Handle
            type="source"
            position={Position.Right}
            id={handle.id}
            className="!w-3 !h-3 !bg-white !border-2 !border-primary/60 dark:!border-primary/80 dark:!bg-dark-bg transition-all hover:!border-primary hover:!bg-primary/10 hover:scale-110 !absolute !right-[-6px] !top-[-6px] !transform-none"
          />
        </div>
      ))}
    </div>
  );
};
